import HideableCellValue from "common_components/flowmaster/llm_run/hideable_cell_value";
import React from "react";
import renderLink from "routes/llm_run/llm_run_detail/utils/render_link";
import Title from "./title_row_td";
import {styled} from "styled-components";
import formatDateToLocalISOString from "routes/llm_run/utils/format_date_local_iso_string";
import {IconButton} from "@material-ui/core";
import FilterIcon from "@material-ui/icons/FilterList";

const SummaryTitleTd = styled(Title)<{hide: boolean}>`
  cursor: pointer;
`;

function SummaryTitle({handleRowClick, hide, llmRuns}) {
  return (
    <tr>
      <SummaryTitleTd hide={hide} onClick={handleRowClick}>
        Summary
      </SummaryTitleTd>
      {llmRuns.map(run => (
        <Title key={`summaryTitleTd${run.id}`} hide={hide}>
          {hide && "..."}
        </Title>
      ))}
    </tr>
  );
}

function renderFilterButton(key, onFilter) {
  if (!["document_id", "project_id"].includes(key)) {
    return null;
  }

  return (
    <IconButton size="small" style={{padding: 0}} onClick={onFilter}>
      <FilterIcon></FilterIcon>
    </IconButton>
  );
}

export default function SummaryRow({
  organisationId,
  llmRuns,
  summaryKeys,
  showSummary,
  handleShowSummaryChange,
  onFilter,
}) {
  const filterRenderers = {
    creation_date: {
      renderedKey: "start time",
      valueFn: creation_date =>
        creation_date
          ? formatDateToLocalISOString(new Date(creation_date))
          : undefined,
    },
    cost: {
      valueFn: cost => (cost ?? 0).toFixed(4),
    },
  };

  return (
    <>
      <SummaryTitle
        handleRowClick={handleShowSummaryChange}
        hide={!showSummary}
        llmRuns={llmRuns}
      />
      {showSummary &&
        summaryKeys.map(key => {
          const llmRunValues = llmRuns.map(
            run =>
              run[key] ?? run.links[key] ?? run.data.data_store.context[key],
          );

          if (!llmRunValues.some(value => value !== undefined)) {
            return <React.Fragment key={`empty-summary-${key}`} />;
          }

          const renderedKey = filterRenderers[key]?.renderedKey ?? key;

          return (
            <tr key={`summary.${key}`} id={`summary.${key}`}>
              <td
                onClick={handleShowSummaryChange}
                style={{cursor: "pointer", paddingLeft: "1em"}}
              >
                {renderedKey}
              </td>
              {llmRuns.map((run, idx) => {
                const value = llmRunValues[idx];
                const valueRenderer = filterRenderers[key]?.valueFn;
                const renderedValue = valueRenderer
                  ? valueRenderer(value)
                  : value;
                const renderedLink = renderLink(organisationId, key, {
                  ...run.links,
                  ...run.data.data_store.context,
                });
                const renderedFilterButton = renderFilterButton(key, () =>
                  onFilter({[key]: value}),
                );
                return (
                  <td key={`summary.${key}.${run.id}`}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5em",
                      }}
                    >
                      <HideableCellValue hide={false}>
                        {renderedValue ?? "-"}
                      </HideableCellValue>
                      {renderedLink}
                      {renderedFilterButton}
                    </div>
                  </td>
                );
              })}
            </tr>
          );
        })}
    </>
  );
}
